// @flow
import React, { PureComponent } from 'react';
import { Select } from '../../../../components/ui/forms';

class RoomsSelect extends PureComponent {
  props: {
    value: string,
    onChange: Function,
    name: string,
  }

  render() {
    return (
      <Select
        onChange={this.props.onChange}
        value={this.props.value}
      >
        <option value="">---</option>
        {Array.apply(null, Array(9)).map((_, i) => (
          <option key={i} value={i + 1}>{i + 1}+</option>
        ))}
      </Select>
    );
  }
}

export default RoomsSelect;



// WEBPACK FOOTER //
// ./src/components/BuildingsView/FiltersBar/RoomsSelect/index.js